// =============================================================
// SEO / GEO 全局配置
// 站点元信息 + 各路由独立 meta 配置（供 useSeo composable 使用）
// GEO（生成式引擎优化）：结构化数据 + FAQ + 清晰的实体与语义
// =============================================================

export const SITE = {
  url: 'https://www.hftopos.com',
  name: '航富通',
  fullName: '航富通 - 让每一家零售门店，都数字化经营',
  lang: 'zh-CN',
  description:
    '航富通 · 为服饰、箱包、鞋帽、家纺、文具、百货门店打造的开单收银与门店管理利器。航富通标准版与航富通 Nova 旗舰版，一套系统撑起整个零售生意。',
  keywords:
    '航富通,收银系统,进销存,门店管理,零售软件,开单收银,连锁管理,Nova,收银系统哪个好,门店进销存系统',
  ogImage: '/favicon.svg',
  themeColor: '#241638',
  author: '江苏宜航信息技术有限公司',
}

// 路由名 -> 页面级 meta（title / description / canonical / ogType）
export const routeMeta = {
  home: {
    title: '航富通 - 让每一家零售门店，都数字化经营',
    description:
      '航富通 · 为文创、饰品、潮玩、谷子、服装、珠宝、美妆、手作、杂货门店打造的开单收银与门店管理利器。航富通标准版与 Nova 旗舰版，一套系统撑起整个零售生意。',
    keywords:
      '航富通,收银系统,进销存,门店管理,零售软件,开单收银,审美零售,新零售收银系统',
    ogType: 'website',
    path: '/',
  },
  'product-standard': {
    title: '航富通标准版 - 开单收银 · 进销存 · 会员 · 报表',
    description:
      '航富通标准版为文创、饰品、潮玩、谷子、服装、珠宝、美妆、手作、杂货门店提供开单收银、进销存管理、会员体系、员工管理与经营报表的一站式管理工具。',
    keywords:
      '航富通标准版,门店管理系统,进销存软件,收银开单,会员管理,服装收银系统,潮玩店收银系统',
    ogType: 'website',
    path: '/product/standard',
  },
  'product-nova': {
    title: '航富通 Nova 旗舰版 - 更快 · 更省心 · 先人一步',
    description:
      '航富通 Nova 是旗舰版，在航富通全部能力之上带来更快的性能、更便捷的操作与更快的功能迭代，为追求更好体验的审美门店而生。',
    keywords:
      '航富通Nova,旗舰版收银系统,快捷收银,新零售软件,高性能门店系统,智能开单',
    ogType: 'website',
    path: '/product/nova',
  },
  compare: {
    title: '航富通 vs 航富通 Nova - 标准版与旗舰版对比',
    description:
      '航富通标准版与 Nova 旗舰版详细对比：核心功能一致，Nova 在性能、操作便捷、功能迭代与专属服务上更进一步。看看哪个版本更适合你的门店。',
    keywords:
      '航富通对比,Nova对比,收银系统对比,标准版,旗舰版,门店系统怎么选',
    ogType: 'website',
    path: '/compare',
  },
  about: {
    title: '关于我们 - 江苏宜航信息技术有限公司',
    description:
      '江苏宜航信息技术有限公司，一站式零售收银与门店管理系统服务商，帮助商户把好品味做成好生意，让门店经营更高效、更轻松、更懂年轻人。',
    keywords:
      '江苏宜航,航富通公司,零售软件服务商,收银系统公司,门店管理系统',
    ogType: 'website',
    path: '/about',
  },
}

// 页面级 FAQ（生成式引擎优化：直接、明确、可引用的答案）
export const faqs = [
  {
    question: '航富通是什么？',
    answer:
      '航富通是面向文创、饰品、潮玩、谷子、服装、珠宝、美妆、手作、杂货等审美零售门店的开单收银与门店管理软件，提供开单收银、进销存、会员营销、经营报表与员工管理的一站式能力。',
  },
  {
    question: '航富通标准版和航富通 Nova 有什么区别？',
    answer:
      '航富通标准版覆盖开单收银、进销存、会员、报表与员工管理等核心能力；航富通 Nova 是旗舰版，在标准版全部能力之上，提供更快的性能、更便捷的操作、更快的功能迭代与专属服务。',
  },
  {
    question: '航富通适合哪些行业门店？',
    answer:
      '航富通适合文创、饰品、潮玩、谷子、服装、珠宝、美妆、手作、杂货等审美新零售门店及个体商贸客户，帮助门店高效开单收银、管好进销存。',
  },
  {
    question: '航富通包含哪些核心功能？',
    answer:
      '航富通核心功能包括：高效上货与条码录入、智慧扫码开单与快捷收银、进销存管理与库存预警、会员体系与充值管理、员工权限与多维度提成、经营数据报表。',
  },
  {
    question: '航富通支持移动端和小程序吗？',
    answer:
      '支持。航富通提供「富小宝」掌上管店 App，可随时随地远程巡店、查看经营 BI、洞察会员；并提供「小富在线」专属小程序，支持会员自主下单、24 小时微商城与虚拟导购。',
  },
  {
    question: '航富通硬件套餐有哪几种？',
    answer:
      '航富通提供手机套餐、通用套餐、平板套餐与一体机套餐。标准版手机套餐官方标配 888 元、通用套餐 1288 元；Nova 对应配置价格更高，部分套餐暂未开放，欢迎咨询获取最新价格。',
  },
]



// WEBPACK FOOTER //
// ./src/site/data/seo.js